import { render, staticRenderFns } from "./place-cards-wrapper.vue?vue&type=template&id=54ca22f2"
import script from "./place-cards-wrapper.vue?vue&type=script&lang=ts"
export * from "./place-cards-wrapper.vue?vue&type=script&lang=ts"
import style0 from "./place-cards-wrapper.vue?vue&type=style&index=0&id=54ca22f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports